/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { Typography } from "@mui/material";
import { Error } from "@mui/icons-material";

const UnknownCell = () => {
  return (
    <div
      style={{
        display: "flex",
        padding: 5,
        background: "#e57373",
        borderRadius: 5,
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <Error fontSize="small" color="inherit" />
        <Typography variant="caption" maxWidth={50} noWrap={true}>
          Unknown
        </Typography>
      </div>
    </div>
  );
};
export default UnknownCell;
